import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const data = [

{ name:"Rahul", completed:35 },
{ name:"Neha", completed:34 },
{ name:"Aman", completed:40 },
{ name:"Priya", completed:28 }

];

const DesignerChart = () => (

<div className="card shadow-sm">

<div className="card-body">

<h5>Daily Productivity</h5>

<ResponsiveContainer width="100%" height={300}>
<BarChart data={data}>
<XAxis dataKey="name"/>
<YAxis/>
<Tooltip/>
<Bar dataKey="completed"/>
</BarChart>
</ResponsiveContainer>

</div>

</div>

);

export default DesignerChart;